/**
 * Build unique location options from jobs and optional altJobs.
 * AltJob-only locations get isAltJob=true flag.
 * Locations that exist in both Job and AltJob are NOT marked as altJob (Job takes priority).
 * No duplicates — deduplication by location name (case-insensitive).
 */
export function buildLocationOptions(jobs, altJobs = []) {
    const seen = new Map();

    // First pass: regular jobs
    jobs.forEach(job => {
        const rawLocation = job.location || job.Location || '';
        if (!rawLocation) return;
        const key = rawLocation.trim().toLowerCase();
        if (!seen.has(key)) {
            seen.set(key, {
                label: rawLocation,
                jobCodes: [job.Job],
                siteAddress: job.siteAddress || job.SiteAddress || '',
                isAltJob: false
            });
        } else {
            const existing = seen.get(key);
            if (job.Job && !existing.jobCodes.includes(job.Job)) {
                existing.jobCodes.push(job.Job);
            }
        }
    });

    // Second pass: alt jobs — only add if location not already from regular jobs
    altJobs.forEach(altJob => {
        const rawLocation = altJob.Location || altJob.location || '';
        if (!rawLocation) return;
        const key = rawLocation.trim().toLowerCase();
        if (!seen.has(key)) {
            seen.set(key, {
                label: rawLocation,
                jobCodes: [altJob.Job],
                siteAddress: '',
                isAltJob: true
            });
        } else {
            const existing = seen.get(key);
            if (altJob.Job && !existing.jobCodes.includes(altJob.Job)) {
                existing.jobCodes.push(altJob.Job);
            }
        }
    });

    return Array.from(seen.values()).sort((a, b) =>
        a.label.localeCompare(b.label)
    );
}

/**
 * Вариант из списка джобов, которому соответствует название локации, или null.
 *
 * null означает, что локацию вписали руками (в расписании, через Add location
 * или прямо в поле формы) — её адреса в справочнике нет. Сравнение — без
 * регистра и крайних пробелов, как и дедупликация в buildLocationOptions:
 * «aether fuels » — это тот же джоб, что «Aether Fuels».
 */
export function findLocationOption(label, options) {
    const key = (label || '').trim().toLowerCase();
    if (!key) return null;
    return (options || []).find((option) => option.label.trim().toLowerCase() === key) || null;
}
